"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationBudget = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    width: "244",
    height: "164",
    viewBox: "0 0 244 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      "clip-path": "url(#clip0_3227_55494)",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M141.592 27.2215C126.09 26.6738 111.325 21.5679 97.2273 15.9824C83.1297 10.3969 69.1626 4.20627 54.0336 1.24625C44.3013 -0.656766 33.1717 -0.925277 25.3311 4.39593C17.7837 9.51043 13.6803 17.96 12.3707 26.156C11.3842 32.336 12.4704 39.2278 15.1709 45.0072C17.0476 49.0199 20.3794 52.3912 22.6841 56.2335C30.698 69.6058 25.038 86.0958 16.3457 99.1526C12.2799 105.277 7.54433 111.121 4.40082 117.639C1.25731 124.158 -0.197817 131.63 2.55195 138.281C5.28032 144.874 11.777 149.825 18.8152 153.307C33.1118 160.382 49.4336 164 65.946 164C102.766 164 139.147 163.892 175.774 163.892C189.282 163.892 202.82 163.071 216.096 160.942C223.466 159.759 231.076 157.884 236.425 153.354C243.22 147.6 244.904 137.867 240.35 130.658C232.721 118.569 211.607 115.568 206.27 102.586C203.332 95.4425 206.349 87.4852 210.618 80.8491C219.777 66.6372 235.129 54.1685 235.938 37.9215C236.494 26.7633 229.113 15.5882 217.703 10.3096C205.741 4.76886 189.157 5.47211 180.332 14.6313C171.246 24.0782 155.278 27.7074 141.592 27.2215Z",
        fill: "#E6EDFB"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M151.092 77.1416H10.6306V155.57C10.6306 160.446 14.604 164.399 19.5055 164.399H140.526C146.362 164.399 151.092 159.693 151.092 153.889V77.1416Z",
        fill: "#88A9F0"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M151.092 60.937H27.8214V77.5574L133.482 77.5568L133.482 155.64C133.482 160.477 137.424 164.399 142.287 164.399C147.15 164.399 151.092 160.477 151.092 155.64L151.092 60.937Z",
        fill: "#1657E2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M151.092 60.937H27.8214V77.5574L133.482 77.5568L133.482 155.64C133.482 160.477 137.424 164.399 142.287 164.399C147.15 164.399 151.092 160.477 151.092 155.64L151.092 60.937Z",
        fill: "black",
        "fill-opacity": "0.201016"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M41.0288 25.2031H129.079V77.5573H41.0288V25.2031Z",
        fill: "#88A9F0"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M41.0288 25.2031H129.079V77.5573H41.0288V25.2031Z",
        fill: "white",
        "fill-opacity": "0.501748"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M27.8213 51.3804H115.872V78.43H27.8213V51.3804Z",
        fill: "#1657E2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M27.8213 51.3804H115.872V78.43H27.8213V51.3804Z",
        fill: "white",
        "fill-opacity": "0.502841"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M41.0288 77.5571H115.872V155.216H41.0288V77.5571Z",
        fill: "#1657E2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M21.6577 41.7817H109.708V155.216H21.6577V41.7817Z",
        fill: "white"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M48.36 87.1348H78.0356V93.3216H48.36V87.1348Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M84.6302 87.1348H101.117V93.3216H84.6302V87.1348Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M30.7741 87.1348H39.5669V93.3216H30.7741V87.1348Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M30.7744 52.8682H101.117V76.9215H30.7744V52.8682Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M48.3598 101.535H75.0679V107.721H48.3598V101.535Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M84.6303 101.535H96.9951V107.721H84.6303V101.535Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M48.36 129.961H78.0356V136.148H48.36V129.961Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M84.63 129.961H99.0557V136.148H84.63V129.961Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M30.7741 101.535H40.666V107.721H30.7741V101.535Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M30.7741 129.961H41.7651V136.148H30.7741V129.961Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M48.36 115.935H71.1113V122.121H48.36V115.935Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M84.6302 115.935H101.117V122.121H84.6302V115.935Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M30.7746 115.935H38.4683V122.121H30.7746V115.935Z",
        fill: "#C3D4F7"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M226.318 45.9199H136.288C135.074 45.9199 134.09 46.8989 134.09 48.1066V103.782C134.09 104.99 135.074 105.969 136.288 105.969H226.318C227.532 105.969 228.516 104.99 228.516 103.782V48.1066C228.516 46.8989 227.532 45.9199 226.318 45.9199Z",
        fill: "#00226C"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M227.513 45.9199H141.069C139.855 45.9199 138.871 46.8989 138.871 48.1066V104.96C138.871 106.168 139.855 107.147 141.069 107.147H227.513C228.727 107.147 229.712 106.168 229.712 104.96V48.1066C229.712 46.8989 228.727 45.9199 227.513 45.9199Z",
        fill: "#1657E2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        opacity: "0.502511",
        d: "M204.611 74.1782H173.534V80.0654H204.611V74.1782Z",
        fill: "#C3D0D8"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M214.324 54.6665H124.198C122.984 54.6665 122 55.6455 122 56.8532V109.333C122 110.541 122.984 111.52 124.198 111.52H214.324C215.538 111.52 216.523 110.541 216.523 109.333V56.8532C216.523 55.6455 215.538 54.6665 214.324 54.6665Z",
        fill: "#C3D0D8"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M218.721 54.6665H127.496C126.282 54.6665 125.297 55.6455 125.297 56.8532V109.333C125.297 110.541 126.282 111.52 127.496 111.52H218.721C219.935 111.52 220.919 110.541 220.919 109.333V56.8532C220.919 55.6455 219.935 54.6665 218.721 54.6665Z",
        fill: "white"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M212.126 72.1597H164.865V76.533H212.126V72.1597Z",
        fill: "#C3D0D8"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M212.126 63.4131H179.153V67.7864H212.126V63.4131Z",
        fill: "#C3D0D8"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M220.919 96.2134H124.198V102.773H220.919V96.2134Z",
        fill: "#C3D0D8"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M204.193 144.932H156.167V164H204.193V144.932Z",
        fill: "#1657E2"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M204.193 130.631H156.167V144.932H204.193V130.631Z",
        fill: "#00226C"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M204.193 111.564H156.167V130.632H204.193V111.564Z",
        fill: "#FEC9C8"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M204.193 111.564H156.167V117.523H204.193V111.564Z",
        fill: "black",
        "fill-opacity": "0.102273"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M194.588 92.4961C199.893 92.4961 204.193 96.7739 204.193 102.051V128.248H184.983V102.051C184.983 96.7739 189.283 92.4961 194.588 92.4961Z",
        fill: "#FEC9C8"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M218.92 132.958H197.848V165.093H218.92V132.958Z",
        fill: "#FDD33F"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M203.948 132.958H197.848V165.093H203.948V132.958Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M215.593 132.958H212.266V165.093H215.593V132.958Z",
        fill: "#FFE168"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M206.72 141.823H203.393V147.363H206.72V141.823Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M206.72 159.553H203.393V165.093H206.72V159.553Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M218.92 138.499H197.848V141.823H218.92V138.499Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M218.92 147.363H197.848V150.688H218.92V147.363Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M218.92 156.229H197.848V159.553H218.92V156.229Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M233.338 141.823H212.266V165.093H233.338V141.823Z",
        fill: "#FDD33F"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M218.366 138.499H212.266V165.093H218.366V138.499Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M230.011 141.823H227.238V165.093H230.011V141.823Z",
        fill: "#FFE168"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M221.138 150.688H217.811V156.228H221.138V150.688Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M233.338 147.363H212.266V150.688H233.338V147.363Z",
        fill: "#F7B523"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M233.338 156.229H212.266V159.553H233.338V156.229Z",
        fill: "#F7B523"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
        id: "clip0_3227_55494",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
          width: "244",
          height: "164",
          fill: "white"
        })
      })
    })]
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationBudget')(IllustrationBudget);